module.exports = __webpack_public_path__ + "img/close-icon.492547bb.svg";